/**
 * SHELL — boot/loading screen shown while the day's course and renderer warm up.
 */

import type { Screen } from '../router';
import { div } from '../dom';
import { brand, spinner } from '../components';

export function loadingScreen(message = 'Preparing today’s roll…'): Screen {
  const screen = div('dr-screen');
  const card = div('dr-card');
  card.append(brand());
  card.append(spinner(message));
  screen.append(card);
  return { node: screen };
}

/** Error fallback when the course/renderer cannot be created. */
export function errorScreen(message: string, onRetry?: () => void): Screen {
  const screen = div('dr-screen');
  const card = div('dr-card');
  card.append(brand());
  card.append(div('dr-banner dr-banner--err', div('', message)));
  if (onRetry) {
    const btn = div('dr-btn dr-btn--primary dr-btn--block');
    btn.textContent = 'Retry';
    btn.setAttribute('role', 'button');
    btn.tabIndex = 0;
    btn.addEventListener('click', onRetry);
    card.append(btn);
  }
  screen.append(card);
  return { node: screen };
}
